webpackJsonp([154107208210465],{

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _BackgroundImageSection = __webpack_require__(57);
	
	var _BackgroundImageSection2 = _interopRequireDefault(_BackgroundImageSection);
	
	var _Section = __webpack_require__(58);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    usecase: {
	        margin: '3.53rem 0.5rem',
	        '& .iframe-container': {
	            position: 'relative',
	            margin: '0 auto',
	            paddingBottom: '56.25%',
	            paddingTop: 35,
	            height: 0,
	            overflow: 'hidden'
	        },
	        '& .iframe-container > iframe': {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: '100%',
	            height: '100%'
	        }
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(function (_ref) {
	    var classes = _ref.classes,
	        data = _ref.data;
	
	    var usecases = data.usecases.edges.map(function (usecase, index) {
	        return _react2.default.createElement(
	            _Section2.default,
	            { key: index },
	            _react2.default.createElement('div', {
	                className: classes.usecase,
	                dangerouslySetInnerHTML: { __html: usecase.node.html }
	            })
	        );
	    });
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _BackgroundImageSection2.default,
	            {
	                sizesBackground: data.imageBackground.childImageSharp.sizes },
	            _react2.default.createElement(
	                'h1',
	                null,
	                data.contents.usecase.title
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                data.contents.usecase.description
	            )
	        ),
	        usecases
	    );
	});
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-usecase-js-33ca35e775cc27f4739c.js